import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { LookupsResourcesAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getIntervals = createAsyncThunk<LookupsResourcesAPI[]>(
  `${Slices.INTERVALS_LIST}/get`,
  async (_, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get('/lookups/jobs/interval');
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
